import i18n from "i18next";
import type { FC } from "react";

import type { AntCustomFormField } from "../../types/types";

interface FileContentsProps extends AntCustomFormField<File | boolean> {
    name: string;
    readOnly: boolean;
    isSiblingContentPresent?: boolean;
}

export const FileContents: FC<FileContentsProps> = ({ readOnly, onChange, name, value, isSiblingContentPresent }) => {
    const onSelectedFile = (ev: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            const { files } = ev.target;
            const file = files?.item(0);
            if (file) {
                onChange(file);
            }
        }
    };

    const deleteFile = () => {
        // set the value to true to indicate that the file should be deleted
        if (onChange) {
            onChange(true);
        }
    };

    return (
        <>
            <input type="file" name={`file-${name}`} disabled={!!value || readOnly} onChange={onSelectedFile} />
            {value && isSiblingContentPresent && (
                <label>
                    <input type="checkbox" name={`delete-file-${name}`} disabled={readOnly} onChange={() => deleteFile()} />
                    {i18n.t("form.file.delete")}
                </label>
            )}
        </>
    );
};
